export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7684.3dcb69b6.jpg";